import { Component, ViewChild } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize, tap } from 'rxjs/operators';

import { isAPIApplicationException } from '../../../core/helpers';
import { AccountStepperComponent, LoginComponent } from '../../components';
import { AuthService } from '../../services';

@Component({
    selector: 'app-sign-in',
    templateUrl: './sign-in.component.html',
    styleUrls: ['./sign-in.component.scss'],
    standalone: false
})
export class SignInComponent {
    private _emailOrPhone: string | undefined;

    @ViewChild(AccountStepperComponent) stepper:
        | AccountStepperComponent
        | undefined;

    @ViewChild(LoginComponent) login: LoginComponent | undefined;

    loginBusy = false;

    constructor(private readonly _auth: AuthService) {}

    emailOrPhoneProvided(emailOrPhone: string) {
        this._emailOrPhone = emailOrPhone;
        this.loginBusy = true;
        this._auth
            .requestSignInCode(this._emailOrPhone)
            .pipe(
                tap(() => this.stepper?.next()),
                catchError((e) => this.handleCodeRequestError(e)),
                finalize(() => (this.loginBusy = false))
            )
            .subscribe();
    }

    codeProvided(code: number) {
        if (this._emailOrPhone)
            this._auth.signIn(this._emailOrPhone, code).subscribe();
    }

    goBack(): void {
        this.stepper?.previous();
    }

    private handleCodeRequestError(e: any): Observable<never> {
        if (isAPIApplicationException(e)) {
            this.login?.emailOrPhone?.setErrors({
                invalidEmailOrPhoneNumber: true
            });
        }
        return throwError(e);
    }
}
